import { ScreenInfoContext } from '@hai/ui-react';
import React, { ReactNode, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from 'src/js/sidebar/sidebar';

interface Props {
  children?: ReactNode;
}

const Layout: React.FunctionComponent<Props> = (props) => {
  const { mobileMode } = useContext(ScreenInfoContext);
  // console.log('mobileMode', mobileMode);
  return (
    <div className={mobileMode ? 'layout-with-sidebar mobile_disabled' : 'layout-with-sidebar'}>
      <Sidebar />
      <Outlet />
      {props.children}
    </div>
  );
};

export default Layout;
